import { chakra, Text } from '@chakra-ui/react';
import React, { ReactNode } from 'react';

type HeroSubtitleProps = {
  children: ReactNode;
  className?: string;
};

/**
 * Hero Subtitle component
 */
export default chakra(function HeroSubtitle_({
  children,
  className,
}: HeroSubtitleProps) {
  return (
    <Text
      className={className}
      color='gray.700'
      size='p1'
      mb='20px'
      textAlign={{ lg: 'left', base: 'center' }}
    >
      {children}
    </Text>
  );
});
